import SimpleDataTable from "lib/components/common/simple-data-table";
import { EMPTY_GUID } from "lib/constants";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { SUBSCRIPTIONS_COLUMNS } from "lib/constants/table-columns";
import useSubscriptions from "lib/hooks/useSubscription";
import { useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Subscriptions = () => {
  const navigateTo = useNavigate();
  const { subscriptions, getSubscriptions, loading, error } =
    useSubscriptions();

  useEffect(() => {
    getSubscriptions();
  }, []);

  const handleSubscriptionUpsert = (subscriptionId?: string) =>
    navigateTo(
      PAGE_ROUTES.ADMIN.UpsertConfigurations.replace(
        ":id",
        subscriptionId ?? EMPTY_GUID
      )
    );

  return (
    <Row>
      <Col xs="12">
        <SimpleDataTable
          isLoading={loading}
          error={error}
          data={subscriptions ?? []}
          columns={SUBSCRIPTIONS_COLUMNS}
          title="Subscriptions"
          onRowClick={(row) =>
            handleSubscriptionUpsert((row as SubscriptionDetails)?.id)
          }
          action={
            <Button onClick={() => handleSubscriptionUpsert()}>
              Add Subscription
            </Button>
          }
        />
      </Col>
    </Row>
  );
};
export default Subscriptions;
